"use client"

import { useState, useEffect } from "react"
import Link from "next/link"
import { X } from "lucide-react"
import { cn } from "@/lib/utils"

export type StickyBlogCTAProps = {
    text?: string
    linkLabel?: string
    href?: string
    closeLabel?: string
}

export function StickyBlogCTA({
    text = "IT-Probleme? Ich helfe.",
    linkLabel = "Kostenlosen IT-Check vereinbaren →",
    href = "/#contact",
    closeLabel = "Schließen",
}: StickyBlogCTAProps = {}) {
    const [isVisible, setIsVisible] = useState(false)
    const [isDismissed, setIsDismissed] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            // Show after scrolling 40% of the page
            const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight)
            if (scrollPercent > 0.4 && !isDismissed) {
                setIsVisible(true)
            }
        }

        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)
    }, [isDismissed])

    if (isDismissed) return null

    return (
        <div
            className={cn(
                "fixed bottom-0 left-0 right-0 z-40 transition-all duration-300 border-t bg-background/95 backdrop-blur",
                isVisible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
            )}
        >
            <div className="container flex items-center justify-between gap-4 py-3">
                <p className="text-sm font-medium">
                    {text}{" "}
                    <Link href={href} className="text-primary hover:underline font-semibold">
                        {linkLabel}
                    </Link>
                </p>
                <button
                    onClick={() => setIsDismissed(true)}
                    className="shrink-0 p-1 text-muted-foreground hover:text-foreground transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
                    aria-label={closeLabel}
                >
                    <X className="h-4 w-4" />
                </button>
            </div>
        </div>
    )
}
